import { useState, useRef, useEffect } from "react";
import { useRaspStore } from "../store/raspStore.ts";
import { olympiadService } from "../services/OlympiadService";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

// getUserIdFromJWT removed - using LoginContext

export const useOlympiadViewModel = (userId: string, appId: string) => {
  const [fields, setFields] = useState<any[]>([]);
  const [foreignKeyData, setForeignKeyData] = useState<any>({});
  const [enums, setEnums] = useState<any>({});
  const [dataToSave, setDataToSave] = useState<any>({});
  const [fetchedForeign, setFetchedForeign] = useState<Set<string>>(new Set());
  const [fetchedEnum, setFetchedEnum] = useState<Set<string>>(new Set());
  const addSubmission = useRaspStore((s) => s.addSubmission);
  const getSubmissions = useRaspStore((s) => s.getSubmissions);
  const getUserAllData = useRaspStore((s) => s.getUserAllData);
  useEffect(() => {
    const dataFromStore = getSubmissions(userId, "Olympiad");
    const allData = getUserAllData(userId);
    console.log(
      "all data from store for student resource",
      dataFromStore,
      allData,
    );
  }, []);
  const loadMetadata = async () => {
    const metadata = await olympiadService.getMetadata();
    const metaFields = metadata[0].fieldValues || [];

    setFields(metaFields);
    // FOREIGNS
    for (let field of metaFields) {
      if (field.foreign) {
        const foreignName = field.foreign;

        if (!fetchedForeign.has(foreignName)) {
          const updated = new Set(fetchedForeign);
          updated.add(foreignName);
          setFetchedForeign(updated);

          const data = await olympiadService.getForeignResource(foreignName);

          setForeignKeyData((prev: any) => ({
            ...prev,
            [foreignName]: data,
          }));
        }
      }
    }

    // ENUMS
    for (let field of metaFields) {
      if (field.isEnum) {
        const enumName = field.possible_value;

        if (!fetchedEnum.has(enumName)) {
          const updatedEnum = new Set(fetchedEnum);
          updatedEnum.add(enumName);
          setFetchedEnum(updatedEnum);

          const values = await olympiadService.getEnum(enumName);

          setEnums((prev: any) => ({
            ...prev,
            [enumName]: values,
          }));
        }
      }
    }
  };

  const save = async () => {
    const params = new FormData();

    let selectedFile = null;
    selectedFile = Object.keys(dataToSave).filter(
      (key) => dataToSave[key] instanceof File,
    );
    if (selectedFile !== undefined && selectedFile.length > 0) {
      params.append("file", dataToSave[selectedFile[0]]);
      dataToSave[selectedFile[0]] = "";

      params.append("description", "my description");
      params.append("appId", "hostel_management_system");
      params.append("dmsRole", "admin");
      params.append("user_id", "admin@rasp.com");
      params.append("tags", "t1,t2,attend");
    }
    const jsonString = JSON.stringify(dataToSave);
    const base64Encoded = btoa(jsonString);
    if (dataToSave.id) {
      params.append('action', 'MODIFY');
    }
    params.append("resource", base64Encoded);

    const response = await olympiadService.create({
      params,
    });

    if (response.errCode !== -1) {
      addSubmission(userId, "Student", dataToSave);
      console.log(
        "data initialized in store in create form model",
        getUserAllData(userId),
      );
    }
  };

  return {
    fields,
    setFields,
    enums,
    foreignKeyData,
    setForeignKeyData,
    setEnums,
    dataToSave,
    setDataToSave,
    loadMetadata,
    save,
  };
};
